export default {
  data() {
    return {
      filters: {},
      wildcard: null,  // wildcard search/filters,
    }
  },

  methods: {
    /**
     * Format filters.
     *
     * @return {{filter: any[]}}
     */
    formatFilters() {
      return {filter: Object.values(this.filters)};
    },

    /**
     * Remove filter by key.
     *
     * @param key
     */
    removeFilter(key) {
      delete this.filters[key];
    },

    /**
     * Set filters
     * @param filter
     */
    setFilter(filter) {
      this.filters = {...this.filters, ...filter};
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/with-filters.js